import {
  Stack as ChakraStack,
  StackProps as ChakraStackProps,
} from "@chakra-ui/react";
import type { StackSharedProps } from "./Stack.props";

export default function Stack({
  spacing,
  gap,
  divider,
  separator,
  ...rest
}: StackProps): JSX.Element {
  // In Chakra v3, 'spacing' is replaced by 'gap'
  // We maintain backward compatibility by accepting 'spacing' and mapping it to 'gap'
  const gapValue = gap !== undefined ? gap : spacing;

  // Support both 'divider' (v1/v2) and 'separator' (v3) props
  const separatorValue = separator !== undefined ? separator : divider;

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore -- The error is due to our intersection with the Box props. We don't implement all of Chakra's specific property
  // permutations on the Box props
  return <ChakraStack gap={gapValue} separator={separatorValue} {...rest} />;
}

export type StackProps = StackSharedProps &
  ChakraStackProps & {
    // Add any web specific props here.
  };
